// extracted by mini-css-extract-plugin
export default {"title":"PasswordRecovery_title__GVNGO","text":"PasswordRecovery_text__-YmAm","form":"PasswordRecovery_form__VudE3","requirements":"PasswordRecovery_requirements__jpjAa"};